import { IDataTableColumn, useGridState, useSearchApi } from "nsitools-react";
import * as React from "react";
import { useHistory } from "react-router";

import { DogPersonGridDto, EDogSex, PersonApi, PersonDogsSearch } from "../../../../api";
import { EditButton } from "../../../../components";
import { useAuth } from "../../../../contexts";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { DrupalDataTable } from "../../../common";
import { DrupalFieldSet } from "../../../common/DurpalFieldSet";
import { EDrupalRoutes } from "../../../EDrupalRoutes";

export interface ILiveDogsProps {}

export const LiveDogs: React.FunctionComponent<ILiveDogsProps> = () => {
  const { user } = useAuth();
  const api = useApiService(PersonApi);
  const { t } = useTl();
  const history = useHistory();
  const tableState = useGridState<any>({
    serverMode: true,
    enablePagination: true,
    enableFilter: true,
    availablePageSizes: [5, 10, 15],
    pageSize: 5,
    sortKeys: { name: "ASC" },
  });
  const { totalCount } = tableState;
  const searchFunction = React.useCallback(
    (sObj?) => {
      const sobj = PersonDogsSearch.fromJS({
        ...sObj,
        personId: user.userId,
        hideDead: true,
      });
      return api.searchDogs(sobj);
    },
    [api, user.userId]
  );

  const { loading } = useSearchApi({
    searchFunction,
    tableState,
    initialSearch: true,
    trimSearchObjectStringValues: true,
  });

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        header: () => t(ETLCodes.Action),
        fieldName: "_action",
        computed: true,
        disableSorting: true,
        autoFitContent: true,
        alignment: "center",
        render: (row: DogPersonGridDto) => (
          <EditButton onClick={() => history.push(`${EDrupalRoutes.dog}/${row.dogId}/files`)} secured={false} />
        ),
      },
      {
        header: () => t(ETLCodes.CompleteName),
        fieldName: "name",
      },
      {
        header: () => t(ETLCodes.Breed),
        fieldName: "breedName",
      },
      {
        header: () => t(ETLCodes.Chip),
        fieldName: "dogChip",
      },
      {
        header: () => t(ETLCodes.Sex),
        fieldName: "sex",
        render: (row: DogPersonGridDto) => (row.sex === EDogSex.Female ? "F" : "M"),
      },
      {
        header: () => t(ETLCodes.BirthDate),
        fieldName: "birthDate",
      },
    ],
    [history, t]
  );

  return (
    <DrupalFieldSet title={`${t(ETLCodes.LiveDogs)} (${totalCount})`}>
      <DrupalDataTable tableState={tableState} loading={loading} columns={columns} />
    </DrupalFieldSet>
  );
};
